import isEmpty from "lodash/isEmpty";
import { ObjectIndex } from "types";
import "./table.scss";

type RenderItemHandler<T> = (column: TableColumn, item: T) => React.ReactNode;

export interface TableColumn {
	key: string;
	title: string;
	thStyle?: React.CSSProperties;
	tdStyle?: React.CSSProperties;
	customHeaderElement?: React.ReactNode;
}

export interface TableProps<T> {
	items: T[];
	columns: TableColumn[];
	onRenderItem?: RenderItemHandler<T>;
}

export const renderColumnWithActions = <T extends ObjectIndex>(render: (item: T) => React.ReactNode) =>
	(column: TableColumn, item: T) => {
		if (column.key === "acciones") {
			return (
				<div className="acciones">
					{render(item)}
				</div>
			);
		}

		return item[column.key];
	};

const toColumnHeader = (column: TableColumn, index: number) => {
	return (
		<th key={`tableHeader${index}`} style={column.thStyle}>
			{column.customHeaderElement ?? column.title}
		</th>
	);
}

const toTableRow = <T extends object>(columns: TableColumn[], onRenderItem: RenderItemHandler<T>) => (item: T, index: number) => {
	const toCell = (column: TableColumn, cellIndex: number) => {
		const key = `tableRow${index}_${cellIndex}`;
		return <td key={key} style={column.tdStyle}>{onRenderItem(column, item)}</td>;
	};

	return (
		<tr key={index}>
			{columns.map(toCell)}
		</tr>
	);
};

const defaultRenderItem = <T extends ObjectIndex>(column: TableColumn, registry: T) => registry[column.key];

const Table = <T extends ObjectIndex>({ columns, items, onRenderItem = defaultRenderItem }: TableProps<T>) => {
	return (
		<table className="content-table">
			{isEmpty(items) && <caption className="text-center">No existen registros</caption>}
			<thead>
				<tr>
					{columns.map(toColumnHeader)}
				</tr>
			</thead>
			<tbody>
				{items.map(toTableRow(columns, onRenderItem))}
			</tbody>
		</table>
	);
};

export default Table;